module.exports = __webpack_public_path__ + "reserve_now.c49327b75fa82766ab25.png";


//////////////////
// WEBPACK FOOTER
// /Users/ranjith/eclipse-workspace/monarch-web-contentful/src/assets/img/reserve_now.png
// module id = ../../../../../src/assets/img/reserve_now.png
// module chunks = styles